import { Grid, Stack, TextField, Typography } from "@mui/material"
import { Box } from "@mui/system"
import { useEffect } from "react"
import { StyledAutocomplete } from "shared/styled/General"

const WorkOrderCardDropdown = ({
  vehiclesResult,
  initialValues,
  vehicleIdFromDash,
  setFieldValue,
  setVehicle,
  values,
  handleChange,
  handleBlur,
  touched,
  errors,
  t
}) => {
  useEffect(() => {
    setVehicle(vehicleIdFromDash)
  }, [vehicleIdFromDash])

  return (
    <Grid container>
      <Grid item xs={12} md={6}>
        <Typography pb={1} variant="h6">
          {vehiclesResult
            ? t("global.select_vehicle", "Select vehicle")
            : t("global.selected_vehicle", "Selected vehicle")}
        </Typography>
        {vehiclesResult ? (
          <StyledAutocomplete
            id="vehicleId"
            options={vehiclesResult ? vehiclesResult : null}
            getOptionLabel={(option) => (option ? `${option.regNumber} (${option.internnumber})` : "")}
            value={vehiclesResult ? vehiclesResult.find((i) => i.id === values.vehicleId) : null}
            isOptionEqualToValue={(option, value) => {
              return option.id === value.id
            }}
            onChange={(e, value) => {
              setFieldValue("vehicleId", value?.id)
              setVehicle(value?.id)
            }}
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                <Stack direction="row" spacing={2} justifyContent="space-between">
                  <Box sx={{ fontWeight: 600, minWidth: "100px" }}>{option.regNumber}</Box>
                  <Box sx={{ opacity: 0.6 }}>{option.internnumber}</Box>
                </Stack>
              </li>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                name="vehicleId"
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.vehicleId && errors.vehicleId ? true : false}
                helperText={touched.vehicleId && errors.vehicleId ? errors.vehicleId : null}
              />
            )}
          />
        ) : (
          <Typography variant="bodyLarge">{values.regNumber}</Typography>
        )}
      </Grid>
    </Grid>
  )
}

export default WorkOrderCardDropdown
